import MuiDialog, { type DialogProps } from '@mui/material/Dialog';
import MuiDialogActions, {
  type DialogActionsProps,
} from '@mui/material/DialogActions';
import MuiDialogContent, {
  type DialogContentProps,
} from '@mui/material/DialogContent';
import MuiDialogContentText, {
  type DialogContentTextProps,
} from '@mui/material/DialogContentText';
import MuiDialogTitle, {
  type DialogTitleProps,
} from '@mui/material/DialogTitle';

export const Dialog = ({ children, ...props }: DialogProps) => (
  <MuiDialog {...props}>{children}</MuiDialog>
);

export const DialogActions = ({ children, ...props }: DialogActionsProps) => (
  <MuiDialogActions {...props}>{children}</MuiDialogActions>
);

export const DialogContent = ({ children, ...props }: DialogContentProps) => (
  <MuiDialogContent {...props}>{children}</MuiDialogContent>
);

export const DialogContentText = ({
  children,
  ...props
}: DialogContentTextProps) => (
  <MuiDialogContentText {...props}>{children}</MuiDialogContentText>
);

export const DialogTitle = ({ children, ...props }: DialogTitleProps) => (
  <MuiDialogTitle {...props}>{children}</MuiDialogTitle>
);

export type { DialogTitleProps };
export type { DialogContentTextProps };
export type { DialogContentProps };
export type { DialogActionsProps };
export type { DialogProps };
